/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
// Composables
import { createVuetify } from 'vuetify'
import { VTreeview } from 'vuetify/labs/VTreeview'
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  components: {
    VTreeview,
  },
  //components,
  //directives,
  theme: {
    defaultTheme: 'dark',
  },
})
